import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import Settings from './Settings';
import Auth from './Auth';
import Common from './Common';
import Data from './Data';
import Processors from './Processors';
import TransactionCharges from './TransactionCharges';
import Transactions from './Transactions';
import FdsCards from './FdsCards';
import ProcessingSummaries from './ProcessingSummaries';
import EventLog from './EventLog';
import TimelineLog from './TimelineLog';
import Gateway from './Gateway';
import TransactionLog from "./TransactionLog";
import Aggregate from './Aggregate';
import Date from './Date';
import QueueMessage from './QueueMessage';

export default (history) => combineReducers({
  router: connectRouter(history),
  settings: Settings,
  auth: Auth,
  common: Common,
  data: Data,
  transactions: Transactions,
  processors: Processors,
  transactionCharges: TransactionCharges,
  fdsCards: FdsCards,
  processingSummaries: ProcessingSummaries,
  event_log: EventLog,
  timeline_log: TimelineLog,
  transaction_log: TransactionLog,
  gateway: Gateway,
  date: Date,
  aggregate: Aggregate,
  queue_message: QueueMessage,
});
